import { RichiestaModuloDTOPermessiItem } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTOPermessiItem.ts';
import { type DatiSessioneUtente } from '@framework/api-client/api/users/schemas/datiSessioneUtente.ts';
import { SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import { SubmissionModuleLogic } from '../../submission/submission-module/SubmissionModuleLogic.ts';
import { isManager } from '../delegation/DelegationMachine.ts';
import { hasActionPermission } from './hasActionPermission.ts';
import { type IModuleStateMachineRecord } from './ModuleStateMachine.ts';

export function isModuleWithoutSignAndFullControl(
  record: IModuleStateMachineRecord,
  user: DatiSessioneUtente | null | undefined,
) {
  if (!record.module) return false;
  if (!record.submission) return false;
  const state = record.module.stato;

  return (
    (state === SubmissionModuleState.Completed ||
      state === SubmissionModuleState.Compilation) &&
    !SubmissionModuleLogic.needSign(record.module, record.submission, user) &&
    isManager(record.delegationData, user) &&
    hasActionPermission(record, RichiestaModuloDTOPermessiItem.COMPILAZIONE)
  );
}
